import React, { useState, useEffect } from 'react'
import Dropzone from "react-dropzone";

import { getIconeFile } from './../components/FileViewer/fileviewer'

const Form = (props) => {
    const [file, setFile] = useState(props.file || props.arquivo)
    const [change, setChange] = useState(false)

    const handleDelete = () => {
        if (props.onDelete) {
            props.onDelete(() => setFile(null))
             setFile(null)
        }
        else
            setFile(null)
    }

    useEffect(() => {
        if (props.onSave && change)
            props.onSave(
                file?.File || file,
            );

    }, [props.arquivo, file]);

    useEffect(() => {
        if (!props.arquivo && !props.file)
            setFile(null)
    }, [props.arquivo, props.file]);

    return (
        <div
            className={props.className || "col-md-9"}
            style={{ cursor: "pointer", padding: "0px !important", }}
            onDoubleClick={handleDelete}
            title={"Duplo clique para excluir"}
        >
            <div className='d-flex'>
                {file && <i style={{ fontSize: "15px", }} className="fa fa-trash mr-1" onClick={handleDelete} />}
                <label className="m-0 font-90">{props?.label || 'Documento'}</label>
            </div>
            <a href={file?.preview || file} target="_blank" rel="noopener noreferrer" onDoubleClick={handleDelete} style={{ textDecoration: "none", color: "#000" }}>
                <div style={{
                    backgroundColor: "white", borderRadius: "10% !important",
                    alignContent: "center", alignItems: "center", display: "flex", justifyContent: "center",
                    border: "0.5px solid #E4E4E5",
                    onDoubleClick: handleDelete
                }}>
                    {file &&
                        // <a href={file?.preview || file} target="_blank" rel="noopener noreferrer" onDoubleClick={handleDelete}>
                        <div style={{ padding: "5px", textAlign: "center" }}>
                            <img
                                src={file?.preview || file}
                                alt="Arquivo"
                                onError={(e) => { e.target.src = getIconeFile(file?.type || file?.ext, file?.name) }}
                                className="img-fluid custom-image d-block"
                                style={{ margin: "10px auto", height: "100px" }}
                                title="Clique para excluir o documento"
                                onDoubleClick={handleDelete}
                            />
                            <span>{file?.name}</span>
                        </div>

                        // </a>
                    }
                    {!file &&
                        <Dropzone
                            style={{ width: "100%", heigth: "100%" }}
                            name={props.name}
                            accept={props?.accept || {}}
                            onDrop={(acceptedFiles) => {
                                try {
                                    // console.log("dropzone - ini");
                                    let files = acceptedFiles.map((file, i) => {
                                        let url = URL.createObjectURL(file);
                                        let ext = file.name.split(".");
                                        ext = ext[ext.length - 1];

                                        file.preview = url;
                                        file.ext = ext;

                                        setChange(true)
                                        setFile(file)
                                        return file;
                                    });
                                } catch (e) {
                                    // console.log("Erro ao fazer OnDrop....: ", e);

                                }
                            }}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <section
                                    className={
                                        "drop-box"
                                    }
                                    style={{ width: "100%" }}
                                >
                                    <div
                                        {...getRootProps({
                                            onFocus: (e) => (e.currentTarget.style.outline = "none"),
                                        })}
                                    >
                                        <input
                                            {...getInputProps({
                                                multiple: false,
                                                onClick: (e) => props.data && e.preventDefault(),
                                                // accept: "image/jpg,image/jpeg,image/png",
                                                disabled: props.disabled,
                                            })}
                                        />

                                        <h5 className="text-black text-center"
                                            title="Clique para fazer upload da Documento" style={{ marginTop: "10px" }}
                                        ><i className="fa fa-upload" />Clique para fazer Upload</h5>
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                    }
                </div>
            </a>
        </div>
    )
}

export default Form;